import storage from "../storage";

const asyncPersistWithTTL = (Alpine) => {
  const asyncPersistWithTTL = () => {
    let alias;
    let storeName;

    return Alpine.interceptor(
      (initialValue, getter, setter, path, _key) => {
        const lookup =
          storeName === "alpine_persist"
            ? [initialValue.task_id, initialValue.uuid] // composite key used by alpine_persist store
            : alias || `_x_${path}`; // string key used by the other stores

        // Make the server-provided fallback available while IndexedDB is loading.
        setter(initialValue);

        getInitialValue(lookup, storeName, initialValue).then((value) => {
          setter(value);

          Alpine.effect(() => {
            const value = getter();
            if (value !== undefined) {
              storage.setItem(value, { storeName: storeName });
              setTaskExpirationData(value, storeName);
              setter(value);
            }
          });

          return value;
        });

        return initialValue;
      },
      (func) => {
        func.as = (key) => {
          alias = key;
          return func;
        };
        func.within = (target) => {
          storeName = target;
          return func;
        };
      },
    );
  };

  Alpine.magic("asyncPersistWithTTL", asyncPersistWithTTL);
};

async function getInitialValue(lookup, storeName, initialValue) {
  const persistedValue = await storageGet(lookup, storeName);

  if (persistedValue === null || isEmptyFormValue(persistedValue, storeName)) {
    return initialValue;
  }

  return persistedValue;
}

async function storageGet(lookup, storeName) {
  const value = await storage.getItem(lookup, { storeName: storeName });

  if (value === undefined) return;

  return value;
}

function isEmptyFormValue(value, storeName) {
  return storeName === "alpine_persist" && value?.value === "";
}

async function setTaskExpirationData(value, storeName) {
  if (storeName === "tasks") {
    storage.setItem(
      { id: value.id, lastUsedAt: new Date().toISOString() },
      { storeName: "expiration_data" },
    );
  }
}

export default asyncPersistWithTTL;
